module.exports = __webpack_public_path__ + "d1905f2faad6e5c4c4ea8de8f12612d8.jpg";